import script from "./DataRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DataRow.vue?vue&type=script&setup=true&lang=js"

import "./DataRow.vue?vue&type=style&index=0&id=428811f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_postcss@8.5.31_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428811f4"]])

export default __exports__